import React from 'react';
import { DashboardCard } from './DashboardCard';
import { DollarSignIcon, PencilRulerIcon, PackageIcon, LineChartIcon, BarChart3Icon, ArrowUpDownIcon, FilterIcon, ArrowRightIcon, TrendingUpIcon } from 'lucide-react';
export function QuotesOverview() {
  // Mock data
  const quotesData = {
    total: 2392,
    pivots: 3716,
    spareParts: 0,
    linears: 0,
    conversionRate: '0%'
  };
  const regions = [{
    name: 'Aisco MENA',
    value: 6,
    max: 1600,
    percentage: 0.4
  }, {
    name: 'Aisco AFRICA',
    value: 12,
    max: 1600,
    percentage: 0.8
  }, {
    name: 'Aisco EUROPE',
    value: 650,
    max: 1600,
    percentage: 40.6
  }, {
    name: 'Aisco AMERICA',
    value: 1590,
    max: 1600,
    percentage: 99.4
  }, {
    name: 'Aisco ANZ',
    value: 94,
    max: 1600,
    percentage: 5.9
  }];
  const dealers = [{
    name: 'TEXAS INTERNATIONAL IRRIGATION',
    count: 167
  }, {
    name: 'UWR',
    count: 113
  }, {
    name: 'I-BEAM Irrigation',
    count: 111
  }, {
    name: 'AQUADOC',
    count: 97
  }, {
    name: 'NORTHERN IRRIGATION SYSTEMS',
    count: 92
  }, {
    name: 'CAN AGRO LLP',
    count: 90
  }, {
    name: 'VK SALES & SERVICE',
    count: 81
  }, {
    name: 'IMPER REGAS Lda',
    count: 74
  }];
  return <div className="space-y-6" data-id="element-1940">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1941">
        <DashboardCard icon={<DollarSignIcon size={20} className="text-blue-400" data-id="element-1943" />} title="Total Quotes" className="md:col-span-2" data-id="element-1942">
          <div className="flex flex-col" data-id="element-1944">
            <div className="text-5xl font-bold text-white mb-6" data-id="element-1945">
              {quotesData.total}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" data-id="element-1946">
              <QuoteTypeCard icon={<PencilRulerIcon size={18} data-id="element-1948" />} label="Pivots" value={quotesData.pivots} data-id="element-1947" />
              <QuoteTypeCard icon={<PackageIcon size={18} data-id="element-1950" />} label="Spare parts" value={quotesData.spareParts} data-id="element-1949" />
              <QuoteTypeCard icon={<LineChartIcon size={18} data-id="element-1952" />} label="Linears" value={quotesData.linears} data-id="element-1951" />
            </div>
            <div className="h-40 relative" data-id="element-1953">
              <div className="absolute inset-x-0 bottom-0 flex items-end justify-between px-2" data-id="element-1954">
                {Array.from({
                length: 12
              }, (_, i) => <div key={i} className="flex flex-col items-center" data-id="element-1955">
                      <div className="w-8 bg-blue-500 rounded-t-sm" style={{
                  height: `${Math.random() * 100 + 20}px`
                }} data-id="element-1956"></div>
                      <div className="text-xs text-blue-300 mt-1" data-id="element-1957">
                        {new Date(0, i).toLocaleString('default', {
                    month: 'short'
                  })}
                      </div>
                    </div>)}
              </div>
            </div>
          </div>
        </DashboardCard>
        <DashboardCard icon={<TrendingUpIcon size={20} className="text-blue-400" data-id="element-1959" />} title="Conversion Rate" data-id="element-1958">
          <div className="flex flex-col items-center justify-center h-full" data-id="element-1960">
            <div className="relative w-40 h-40 mb-4" data-id="element-1961">
              <svg viewBox="0 0 100 100" className="w-full h-full" data-id="element-1962">
                <circle cx="50" cy="50" r="40" fill="transparent" stroke="#1e40af" strokeWidth="15" data-id="element-1963" />
                <circle cx="50" cy="50" r="40" fill="transparent" stroke="#3b82f6" strokeWidth="15" strokeDasharray="251.2" strokeDashoffset="251.2" transform="rotate(-90 50 50)" data-id="element-1964">
                  <animate attributeName="stroke-dashoffset" from="251.2" to="251.2" dur="1s" fill="freeze" data-id="element-1965" />
                </circle>
              </svg>
              <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-1966">
                <div className="text-3xl font-bold text-white" data-id="element-1967">
                  {quotesData.conversionRate}
                </div>
                <div className="text-sm text-blue-300" data-id="element-1968">Conversion</div>
              </div>
            </div>
            <div className="text-center" data-id="element-1969">
              <div className="text-sm text-blue-300 mb-2" data-id="element-1970">
                Opportunities for improvement
              </div>
              <button className="inline-flex items-center px-3 py-1.5 rounded-lg bg-blue-500/20 text-blue-300 hover:bg-blue-500/30 transition-colors text-sm" data-id="element-1971">
                View Analysis
                <ArrowRightIcon size={14} className="ml-1" data-id="element-1972" />
              </button>
            </div>
          </div>
        </DashboardCard>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1973">
        <DashboardCard icon={<BarChart3Icon size={20} className="text-blue-400" data-id="element-1975" />} title="Regional Distribution" className="md:col-span-3" data-id="element-1974">
          <div className="space-y-4" data-id="element-1976">
            {regions.map(region => <div key={region.name} className="space-y-2" data-id="element-1977">
                <div className="flex justify-between" data-id="element-1978">
                  <span className="text-sm text-blue-300" data-id="element-1979">{region.name}</span>
                  <span className="text-sm font-medium text-white" data-id="element-1980">
                    {region.value} quotes
                  </span>
                </div>
                <div className="w-full bg-slate-700/50 rounded-full h-2.5 overflow-hidden" data-id="element-1981">
                  <div className="bg-blue-500 h-2.5 rounded-full" style={{
                width: `${region.percentage}%`
              }} data-id="element-1982"></div>
                </div>
                <div className="flex justify-between text-xs text-slate-400" data-id="element-1983">
                  <span data-id="element-1984">0</span>
                  <span data-id="element-1985">{region.max}</span>
                </div>
              </div>)}
          </div>
        </DashboardCard>
      </div>
      <DashboardCard icon={<BarChart3Icon size={20} className="text-blue-400" data-id="element-1987" />} title="Quotes by Dealers" footer={<div className="flex justify-between text-sm text-blue-300" data-id="element-1988">
            <span data-id="element-1989">Showing 8 of 32 dealers</span>
            <button className="text-blue-400 hover:text-white" data-id="element-1990">View All</button>
          </div>} data-id="element-1986">
        <div className="flex justify-end mb-4" data-id="element-1991">
          <div className="flex items-center space-x-2" data-id="element-1992">
            <button className="p-2 rounded-lg bg-slate-800 text-blue-300 hover:bg-slate-700 transition-colors" data-id="element-1993">
              <ArrowUpDownIcon size={16} data-id="element-1994" />
            </button>
            <button className="p-2 rounded-lg bg-slate-800 text-blue-300 hover:bg-slate-700 transition-colors" data-id="element-1995">
              <FilterIcon size={16} data-id="element-1996" />
            </button>
          </div>
        </div>
        <div className="space-y-4" data-id="element-1997">
          {dealers.map((dealer, index) => <div key={index} className="flex items-center" data-id="element-1998">
              <div className="flex-1 text-white" data-id="element-1999">{dealer.name}</div>
              <div className="w-1/2" data-id="element-2000">
                <div className="flex items-center" data-id="element-2001">
                  <div className="flex-1 mr-4" data-id="element-2002">
                    <div className="w-full bg-slate-700/50 rounded-full h-2.5" data-id="element-2003">
                      <div className="bg-blue-500 h-2.5 rounded-full" style={{
                    width: `${dealer.count / 167 * 100}%`
                  }} data-id="element-2004"></div>
                    </div>
                  </div>
                  <div className="text-blue-300 text-sm w-10 text-right" data-id="element-2005">
                    {dealer.count}
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </DashboardCard>
    </div>;
}
function QuoteTypeCard({
  icon,
  label,
  value
}) {
  return <div className="bg-slate-800/50 rounded-lg p-4" data-id="element-2006">
      <div className="flex justify-between items-center mb-2" data-id="element-2007">
        <div className="flex items-center" data-id="element-2008">
          <div className="p-2 rounded-lg bg-slate-700/50 mr-3" data-id="element-2009">
            <span className="text-blue-300" data-id="element-2010">{icon}</span>
          </div>
          <div className="text-sm text-blue-300" data-id="element-2011">{label}</div>
        </div>
        <div className="text-xl font-bold text-white" data-id="element-2012">{value}</div>
      </div>
    </div>;
}